<template>
  <div id="Lgx02887687439268091789342" class="sx">
    <div class="sx-context">
      <vx-card>
        <div class="sx-card-head">
          <h3 class="sx-card-title">Storefront infrastructure</h3>
          <span class="sx-brand">
            <svg viewBox="0 0 448 512" class="sx-brand-logo" aria-hidden="true">
              <path
                d="M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"
              />
            </svg>
            Shopify
          </span>
        </div>
        <svg viewBox="0 0 930 230" role="img" class="sx-diagram">
          <title>shop-app-01 serves the storefront application from /opt/storefront and writes backups to the /backups NFS share on backup-nas-01.</title>
          <g fill="none" stroke-width="1.5" stroke="#2c3a4d">
            <line x1="150" y1="125" x2="190" y2="125" />
            <line x1="360" y1="125" x2="395" y2="125" />
            <line x1="395" y1="70" x2="395" y2="180" />
            <line x1="395" y1="70" x2="430" y2="70" />
            <line x1="395" y1="180" x2="430" y2="180" />
            <line x1="630" y1="70" x2="665" y2="70" />
            <line x1="665" y1="36" x2="665" y2="104" />
            <line x1="665" y1="36" x2="700" y2="36" />
            <line x1="665" y1="104" x2="700" y2="104" />
            <line x1="805" y1="130" x2="805" y2="160" />
          </g>
          <g text-anchor="middle">
            <rect x="20" y="99" width="130" height="52" rx="6" class="sx-node" />
            <text x="85" y="130" class="sx-node-name">Internet</text>

            <rect x="190" y="93" width="170" height="64" rx="6" class="sx-node" />
            <text x="275" y="120" class="sx-node-name">lb-01</text>
            <text x="275" y="140" class="sx-node-sub">HAProxy load balancer</text>

            <rect x="430" y="40" width="200" height="60" rx="6" class="sx-node is-here" />
            <text x="530" y="66" class="sx-node-name">shop-app-01</text>
            <text x="530" y="86" class="sx-node-sub is-here">you are here</text>

            <rect x="430" y="150" width="200" height="60" rx="6" class="sx-node" />
            <text x="530" y="176" class="sx-node-name">shop-app-02</text>
            <text x="530" y="196" class="sx-node-sub">serving traffic</text>

            <rect x="700" y="10" width="210" height="52" rx="6" class="sx-node" />
            <text x="805" y="32" class="sx-node-name sx-node-mono">/opt/storefront</text>
            <text x="805" y="50" class="sx-node-sub">application directory</text>

            <rect x="700" y="78" width="210" height="52" rx="6" class="sx-node" />
            <text x="805" y="100" class="sx-node-name sx-node-mono">/backups</text>
            <text x="805" y="118" class="sx-node-sub">mounted NFS share</text>

            <rect x="700" y="160" width="210" height="52" rx="6" class="sx-node" />
            <text x="805" y="182" class="sx-node-name">backup-nas-01</text>
            <text x="805" y="200" class="sx-node-sub">10.20.4.15 · NFS export</text>
          </g>
        </svg>
      </vx-card>

      <vx-card>
        <h3 class="sx-card-title">CHG-4471 · storefront v4.2 rollout</h3>
        <ul class="sx-timeline">
          <li v-for="entry in timeline" :key="entry.time">
            <span class="sx-time">{{ entry.time }}</span>
            <span>{{ entry.text }}</span>
          </li>
        </ul>
        <dl class="sx-facts">
          <div><dt>Signed in as</dt><dd>root</dd></div>
          <div><dt>Working directory</dt><dd>/root</dd></div>
          <div><dt>Backup format</dt><dd>uncompressed tar</dd></div>
        </dl>
      </vx-card>
    </div>

    <vx-card>
      <ol class="sx-stepper">
        <li v-for="(item, index) in steps" :key="item.key" class="sx-step" :class="stepClass(index)">
          <button type="button" class="sx-step-button" :disabled="!canOpen(index)" @click="openStep(index)">
            <span class="sx-step-dot">
              <font-awesome-icon v-if="stepState(index) === 'correct' || stepState(index) === 'done'" :icon="['far', 'check']" />
              <font-awesome-icon v-else-if="stepState(index) === 'wrong'" :icon="['far', 'xmark']" />
              <span v-else>{{ index + 1 }}</span>
            </span>
            <span class="sx-step-text">
              <span class="sx-step-label">Step {{ index + 1 }}</span>
              <span class="sx-step-title">{{ item.title }}</span>
            </span>
          </button>
        </li>
      </ol>
      <div class="sx-progress">
        <div class="sx-progress-track">
          <div class="sx-progress-fill" :style="{ width: `${progress}%` }"></div>
        </div>
        <span class="sx-progress-label">{{ progress }}% complete</span>
      </div>
    </vx-card>

    <vx-card v-if="activeKey !== 'review'">
      <h3 class="sx-step-heading">{{ steps[step].heading }}</h3>
      <p class="sx-step-copy">{{ steps[step].copy }}</p>

      <div class="sx-bank">
        <button
          v-for="token in tokens"
          :key="token.id"
          type="button"
          class="sx-token"
          :class="{ 'is-space': token.id === 'space', 'is-used': isUsed(token.id) }"
          :disabled="isUsed(token.id)"
          @click="addToken(token.id)"
        >
          {{ token.label }}
        </button>
      </div>

      <div class="sx-terminal" :class="resultClass(activeKey)">
        <div class="sx-command">
          <span class="sx-prompt">root@shop-app-01:~#</span>
          <span class="sx-fixed">tar</span>
          <template v-for="(tokenId, index) in commands[activeKey]">
            <span
              v-if="tokenId === 'space'"
              :key="`${activeKey}-${index}`"
              class="sx-part sx-part-space"
              title="Remove space"
              @click="removeAt(index)"
            ></span>
            <span v-else :key="`${activeKey}-${index}`" class="sx-part" title="Remove" @click="removeAt(index)">{{ tokenValue(tokenId) }}</span>
          </template>
          <span class="sx-cursor" aria-hidden="true"></span>
        </div>
        <div class="sx-terminal-actions">
          <button type="button" class="sx-icon-button" :disabled="!commands[activeKey].length" title="Remove last object" @click="backspace">
            <font-awesome-icon :icon="['far', 'delete-left']" />
          </button>
          <button type="button" class="sx-icon-button" :disabled="!commands[activeKey].length" title="Clear command" @click="clearLine">
            <font-awesome-icon :icon="['far', 'trash-can']" />
          </button>
        </div>
      </div>
      <div v-if="results[activeKey] === true" class="sx-output">
        <p v-for="line in outputLines" :key="line">{{ line }}</p>
      </div>

      <div class="sx-step-footer">
        <button v-if="step > 0" type="button" class="sx-button sx-button-secondary" @click="openStep(step - 1)">Back</button>
        <button type="button" class="sx-button sx-button-primary" :disabled="!commands[activeKey].length" @click="saveAndContinue">
          {{ step === 0 ? 'Save and continue' : 'Save and review' }}
        </button>
      </div>
    </vx-card>

    <vx-card v-else>
      <h3 class="sx-step-heading">{{ steps[step].heading }}</h3>
      <p class="sx-step-copy">{{ steps[step].copy }}</p>

      <div class="sx-review">
        <div v-for="key in buildKeys" :key="key" class="sx-review-row" :class="resultClass(key)">
          <div class="sx-review-head">
            <span class="sx-review-label">{{ steps.find((item) => item.key === key).title }}</span>
            <span v-if="results[key] === true" class="sx-result is-correct">Correct</span>
            <span v-else-if="results[key] === false" class="sx-result is-wrong">Incorrect</span>
            <button type="button" class="sx-link" @click="openStep(buildKeys.indexOf(key))">Edit</button>
          </div>
          <code class="sx-review-code">root@shop-app-01:~# {{ commandText(key) }}</code>
        </div>
      </div>

      <p class="sx-review-note">Both commands are saved. Select Mark Simulation to check them.</p>
    </vx-card>
  </div>
</template>

<script>
const SPACE = 'space';


export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      step: 0,
      buildKeys: ['backup', 'restore'],
      steps: [
        {
          key: 'backup',
          title: 'Back up',
          heading: 'Back up the storefront application',
          copy: 'Build the tar command that creates an uncompressed backup of the storefront application before the rollout.',
        },
        {
          key: 'restore',
          title: 'Restore',
          heading: 'Restore the storefront application',
          copy: 'The rollout failed. Build the tar command that restores the storefront application from your backup.',
        },
        {
          key: 'review',
          title: 'Review',
          heading: 'Review your commands',
          copy: 'Check both commands before you submit. You can go back to either step to change a command.',
        },
      ],
      tokens: [
        '-cvf',
        '/opt/',
        '-xzvf',
        '/backups/storefront.tar',
        'storefront',
        '-tvf',
        '/',
        '-C',
        '-czvf',
        '/backups/storefront.tar.gz',
        '-xvf',
        '/home/',
        SPACE,
        '-d',
        '/backups/storefront.tgz',
        '-cJvf',
        '/srv/',
        '-xjvf',
        '/backups/storefront.tar.bz2',
        '-c',
        '/var/www/',
        '/backups/storefront.tar.xz',
        '/backups/',
        '/root/',
      ].map((value) => {
        if (value === SPACE) return { id: SPACE, label: '␣ space', value: ' ' };
        return { id: value, label: value, value };
      }),
      commands: {
        backup: [],
        restore: [],
      },
      saved: {
        backup: false,
        restore: false,
      },
      results: {
        backup: null,
        restore: null,
      },
      accepted: {
        backup: ['tar -cvf /backups/storefront.tar -C /opt/ storefront', 'tar -C /opt/ -cvf /backups/storefront.tar storefront'],
        restore: [
          'tar -xvf /backups/storefront.tar -C /opt/',
          'tar -C /opt/ -xvf /backups/storefront.tar',
          'tar -xvf /backups/storefront.tar -C /opt/ storefront',
          'tar -C /opt/ -xvf /backups/storefront.tar storefront',
        ],
      },
      outputLines: [
        'storefront/',
        'storefront/package.json',
        'storefront/server.js',
        'storefront/config/',
        'storefront/config/storefront.conf',
        'storefront/public/',
        'storefront/public/index.html',
        'storefront/public/checkout.js',
      ],
      timeline: [
        { time: '09:05', text: 'Back up /opt/storefront to the /backups share before the change window.' },
        { time: '13:40', text: 'Deployment of storefront v4.2 starts on shop-app-01.' },
        { time: '14:12', text: 'Deployment fails partway and corrupts files in /opt/storefront.' },
        { time: '14:20', text: 'Restore /opt/storefront from the 09:05 backup.' },
      ],
    };
  },
  computed: {
    activeKey() {
      return this.steps[this.step].key;
    },
    bothSaved() {
      return this.saved.backup && this.saved.restore;
    },
    progress() {
      const done = Number(this.saved.backup) + Number(this.saved.restore) + Number(this.activeKey === 'review' && this.bothSaved);
      return Math.round((done / this.steps.length) * 100);
    },
  },
  methods: {
    tokenValue(tokenId) {
      return this.tokens.find((token) => token.id === tokenId).value;
    },
    isUsed(tokenId) {
      return tokenId !== SPACE && this.commands[this.activeKey].includes(tokenId);
    },
    touch() {
      this.saved[this.activeKey] = false;
      this.results[this.activeKey] = null;
    },
    addToken(tokenId) {
      if (this.isUsed(tokenId)) return;
      this.commands[this.activeKey].push(tokenId);
      this.touch();
    },
    removeAt(index) {
      this.commands[this.activeKey].splice(index, 1);
      this.touch();
    },
    backspace() {
      this.commands[this.activeKey].pop();
      this.touch();
    },
    clearLine() {
      this.commands[this.activeKey] = [];
      this.touch();
    },
    saveAndContinue() {
      this.saved[this.activeKey] = true;
      if (this.bothSaved) {
        this.step = this.steps.length - 1;
        return;
      }
      this.step = this.buildKeys.findIndex((key) => !this.saved[key]);
    },
    canOpen(index) {
      return this.steps[index].key !== 'review' || this.bothSaved;
    },
    openStep(index) {
      if (this.canOpen(index)) this.step = index;
    },
    stepState(index) {
      const { key } = this.steps[index];
      if (key === 'review') {
        if (this.results.backup === true && this.results.restore === true) return 'correct';
        return this.step === index ? 'active' : 'upcoming';
      }
      if (this.results[key] === true) return 'correct';
      if (this.results[key] === false) return 'wrong';
      if (this.step === index) return 'active';
      return this.saved[key] ? 'done' : 'upcoming';
    },
    stepClass(index) {
      return [`is-${this.stepState(index)}`, { 'is-current': this.step === index }];
    },
    resultClass(key) {
      return { 'is-correct': this.results[key] === true, 'is-wrong': this.results[key] === false };
    },
    commandText(key) {
      const parts = this.commands[key].map((tokenId) => this.tokenValue(tokenId)).join('');
      return `tar ${parts}`.replace(/\s+/g, ' ').trim();
    },
    markSimulation() {
      let totalScore = 0;

      this.buildKeys.forEach((key) => {
        const correct = this.accepted[key].includes(this.commandText(key));
        this.results[key] = correct;
        if (correct) totalScore++;
      });

      if (totalScore === this.buildKeys.length) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
#Lgx02887687439268091789342 {
  --sx-mono: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  --sx-green: #95bf47;
  --sx-green-ink: #0b1a05;
  --sx-red: #e5484d;
  --sx-black: #05070c;
  --sx-raised: #0b1120;
  --sx-line: #1e2738;
  --sx-line-strong: #2c3a4d;
  --sx-heading: #ffffff;
  --sx-text: #e4e9f0;
  --sx-muted: #a6b2c1;

  width: 100%;
  min-width: 0;
  font-size: 1.05rem;

  > * + * {
    margin-top: 1.5rem;
  }
}

.sx-context {
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(0, 1fr);
  gap: 1.5rem;
}

.sx-card-title,
.sx-step-heading {
  margin: 0;
  color: var(--sx-heading);
  font-size: 1.2rem;
  font-weight: 600;
}

.sx-card-title {
  margin-bottom: 1rem;
}

.sx-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.sx-brand {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: var(--sx-muted);
  font-size: 0.9rem;
  font-weight: 600;
}

.sx-brand-logo {
  width: 1rem;
  height: 1rem;
  fill: var(--sx-green);
}

.sx-diagram {
  display: block;
  width: 100%;
  height: auto;
}

.sx-node {
  fill: var(--sx-black);
  stroke: var(--sx-line-strong);
}

.sx-node.is-here {
  stroke: var(--sx-green);
  stroke-width: 1.5;
}

.sx-node-name {
  fill: var(--sx-heading);
  font-size: 15px;
  font-weight: 600;
}

.sx-node-sub {
  fill: var(--sx-muted);
  font-size: 13px;
}

.sx-node-sub.is-here {
  fill: var(--sx-green);
}

.sx-node-mono {
  font-family: var(--sx-mono);
}

.sx-timeline {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: grid;
    grid-template-columns: 3.6rem 1fr;
    gap: 0.75rem;
    color: var(--sx-text);
    line-height: 1.55;
  }

  li + li {
    margin-top: 0.85rem;
  }
}

.sx-time {
  color: var(--sx-muted);
  font-family: var(--sx-mono);
}

.sx-facts {
  margin: 1.25rem 0 0;
  padding-top: 1rem;
  border-top: 1px solid var(--sx-line);

  div {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
  }

  div + div {
    margin-top: 0.4rem;
  }

  dt {
    color: var(--sx-muted);
  }

  dd {
    margin: 0;
    color: var(--sx-text);
    font-family: var(--sx-mono);
  }
}

.sx-stepper {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.sx-step-button {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
}

.sx-step-dot {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border: 1px solid var(--sx-line-strong);
  border-radius: 999px;
  color: var(--sx-muted);
  font-size: 0.9rem;
  font-weight: 600;
}

.sx-step-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.sx-step-label {
  color: var(--sx-muted);
  font-size: 0.85rem;
}

.sx-step-title {
  color: var(--sx-muted);
  font-size: 1.1rem;
  font-weight: 600;
}

.sx-step.is-active .sx-step-dot {
  border-color: var(--sx-green);
  background: var(--sx-green);
  color: var(--sx-green-ink);
}

.sx-step.is-done .sx-step-dot,
.sx-step.is-correct .sx-step-dot {
  border-color: var(--sx-green);
  color: var(--sx-green);
}

.sx-step.is-wrong .sx-step-dot {
  border-color: var(--sx-red);
  color: var(--sx-red);
}

.sx-step.is-current .sx-step-title,
.sx-step.is-done .sx-step-title,
.sx-step.is-correct .sx-step-title {
  color: var(--sx-heading);
}

.sx-progress {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1.25rem;
}

.sx-progress-track {
  flex: 1 1 auto;
  height: 0.4rem;
  overflow: hidden;
  border-radius: 999px;
  background: #121a26;
}

.sx-progress-fill {
  height: 100%;
  border-radius: 999px;
  background: var(--sx-green);
  transition: width 0.3s ease;
}

.sx-progress-label {
  flex-shrink: 0;
  color: var(--sx-muted);
  font-size: 0.95rem;
}

.sx-step-copy {
  margin: 0.4rem 0 0;
  color: var(--sx-text);
  line-height: 1.55;
}

.sx-bank {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(19rem, 100%), 1fr));
  gap: 0.6rem;
  margin-top: 1.5rem;
}

.sx-token {
  min-width: 0;
  padding: 0.65rem 0.8rem;
  border: 1px solid var(--sx-line);
  border-radius: 0.4rem;
  background: var(--sx-raised);
  color: var(--sx-text);
  font-family: var(--sx-mono);
  font-size: 1.02rem;
  line-height: 1.3;
  white-space: nowrap;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: var(--sx-green);
  }

  &.is-space {
    border-style: dashed;
    border-color: var(--sx-line-strong);
    color: var(--sx-muted);
  }

  &.is-used {
    border-color: var(--sx-line);
    border-style: solid;
    background: transparent;
    color: #4d5a6e;
    cursor: not-allowed;
  }
}

.sx-terminal {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-top: 1.5rem;
  padding: 1rem;
  border: 1px solid var(--sx-line);
  border-radius: 0.5rem;
  background: var(--sx-black);

  &.is-correct {
    border-color: var(--sx-green);
  }

  &.is-wrong {
    border-color: var(--sx-red);
  }
}

.sx-command {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
  min-height: 2rem;
  color: var(--sx-text);
  font-family: var(--sx-mono);
  font-size: 1.25rem;
  line-height: 1.6;
}

.sx-prompt {
  margin-right: 0.6rem;
  color: var(--sx-green);
}

.sx-fixed {
  margin-right: 0.6ch;
}

.sx-part {
  border-radius: 0.2rem;
  cursor: pointer;

  &:hover {
    color: var(--sx-red);
    text-decoration: line-through;
  }
}

.sx-part-space {
  display: inline-block;
  width: 0.75ch;
  height: 1.2em;
  border-bottom: 1px dashed var(--sx-line-strong);

  &:hover {
    border-bottom-color: var(--sx-red);
  }
}

.sx-cursor {
  display: inline-block;
  width: 0.6ch;
  height: 1.15em;
  margin-left: 1px;
  background: var(--sx-text);
  animation: sx-blink 1.1s steps(1) infinite;
}

@keyframes sx-blink {
  50% {
    opacity: 0;
  }
}

.sx-terminal-actions {
  display: flex;
  flex-shrink: 0;
  gap: 0.4rem;
}

.sx-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.1rem;
  height: 2.1rem;
  border: 1px solid var(--sx-line);
  border-radius: 0.35rem;
  background: var(--sx-raised);
  color: var(--sx-text);
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: var(--sx-line-strong);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

.sx-output {
  margin-top: 0.75rem;
  color: var(--sx-muted);
  font-family: var(--sx-mono);
  font-size: 1rem;
  line-height: 1.45;

  p {
    margin: 0;
  }
}

.sx-step-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--sx-line);
}

.sx-button {
  padding: 0.55rem 1.1rem;
  border: 1px solid transparent;
  border-radius: 0.4rem;
  font: inherit;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}

.sx-button-primary {
  background: var(--sx-green);
  color: var(--sx-green-ink);
}

.sx-button-secondary {
  border-color: var(--sx-line-strong);
  background: transparent;
  color: var(--sx-text);
}

.sx-review {
  margin-top: 1.5rem;
}

.sx-review-row {
  padding: 1rem;
  border: 1px solid var(--sx-line);
  border-radius: 0.5rem;

  & + & {
    margin-top: 1rem;
  }

  &.is-correct {
    border-color: var(--sx-green);
  }

  &.is-wrong {
    border-color: var(--sx-red);
  }
}

.sx-review-head {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.sx-review-label {
  color: var(--sx-heading);
  font-weight: 600;
}

.sx-result {
  font-size: 0.95rem;
  font-weight: 600;

  &.is-correct {
    color: var(--sx-green);
  }

  &.is-wrong {
    color: var(--sx-red);
  }
}

.sx-link {
  margin-left: auto;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--sx-text);
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

.sx-review-code {
  display: block;
  padding: 0.75rem 0.9rem;
  border-radius: 0.4rem;
  background: var(--sx-black);
  color: var(--sx-text);
  font-family: var(--sx-mono);
  font-size: 1.1rem;
  white-space: pre-wrap;
}

.sx-review-note {
  margin: 1.25rem 0 0;
  color: var(--sx-muted);
}

@media (max-width: 1100px) {
  .sx-context {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 720px) {
  .sx-stepper {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.75rem;
  }

  .sx-progress {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
  }

  .sx-command {
    font-size: 1.05rem;
  }
}
</style>
